import { useContext, useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SettingsIcon from '@/assets/icon-settings.svg?react';
import ChangeModelIcon from '@/assets/icon-change-mdel.svg?react';
import LanguageSelectIcon from '../../assets/icon-language.svg?react';
import { SettingContext } from '@/context/SettingContext';
import useElysiaStore from '@/app/elysia-store';

const SettingDropdown = ({ onInitiatedModelSelect, onInititatedLanguageSelect }) => {
  const chatAgent = useElysiaStore((state) => state.chatAgent);
  const [show, setShow] = useState(false);

  const promptToolsConfig = useElysiaStore((state) => state.promptToolsConfig);

  const { selectedModel, defaultModel, selectedLanguage, defaultLanguage, settingsIconRef } =
    useContext(SettingContext);
  const handleToggle = () => {
    setShow(!show);
  };
  return (
    <>
      <Dropdown show={show} onToggle={handleToggle} drop="up">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip className="tooltip-sidebar">Settings</Tooltip>}
        >
          <Dropdown.Toggle
            variant="light"
            className={`settings ${
              chatAgent === 'app-agent'
                ? selectedLanguage !== defaultLanguage
                  ? 'selected'
                  : ''
                : selectedModel?.name_of_model !== defaultModel?.name_of_model ||
                    selectedLanguage !== defaultLanguage
                  ? 'selected'
                  : ''
            }`}
            ref={settingsIconRef}
            aria-label="Settings"
          >
            <div className="d-flex justify-content-center align-items-center gap-1">
              <SettingsIcon />
            </div>
          </Dropdown.Toggle>
        </OverlayTrigger>

        <Dropdown.Menu className="settings-dropdown">
          {promptToolsConfig.changeModel && (
            <Dropdown.Item
              as="button"
              onClick={() => onInitiatedModelSelect(true)}
              className={
                selectedModel?.name_of_model !== defaultModel?.name_of_model ? 'active' : ''
              }
            >
              <ChangeModelIcon />
              Change Model
            </Dropdown.Item>
          )}
          {promptToolsConfig.changeLanguage && (
            <Dropdown.Item
              as="button"
              onClick={() => onInititatedLanguageSelect(true)}
              className={selectedLanguage !== defaultLanguage ? 'active' : ''}
            >
              <LanguageSelectIcon />
              Change Language
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default SettingDropdown;
